// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"ee7eb104","488":"e4af5582","644":"380f07a3","667":"49ecb916"}[chunkId] + ".chunk.js";
};